export const SpecialistPayoutsTmpReport = {
  en: {
    'Specialist payouts (temporary)': 'Specialist payouts (temporary)',
    From: 'From (inclusive)',
    Till: 'Till (inclusive)',
    'Use time': 'Use time',
    'Client ID': 'Client ID',
    Client: 'Client',
    'Service ID': 'Service ID',
    Service: 'Service',
    'Specialist ID': 'Specialist ID',
    Specialist: 'Specialist',
    'Specialist payout': 'Specialist payout',
    'Export CSV': 'Export CSV',
    'CSV Files': 'CSV Files',
  },
  uk: {
    'Specialist payouts (temporary)': 'Виплати спеціалістам (тимчасово)',
    From: 'З (включно)',
    Till: 'До (включно)',
    'Use time': 'Час використання',
    'Client ID': 'ID клієнта',
    Client: 'Клієнт',
    'Service ID': 'ID послуги',
    Service: 'Послуга',
    'Specialist ID': 'ID спеціаліста',
    Specialist: 'Спеціаліст',
    'Specialist payout': 'Виплата спеціалісту',
    'Export CSV': 'Експорт CSV',
    'CSV Files': 'CSV файли',
  },
};

export const SpecialistPayoutTmpExports = {
  en: {
    'Specialist payouts exports': 'Specialist payouts (temporary) — CSV files',
    'Created At': 'Created At',
    Filename: 'Filename',
    Status: 'Status',
    Error: 'Error',
    Actions: 'Actions',
    Download: 'Download',
  },
  uk: {
    'Specialist payouts exports':
      'Виплати спеціалістам (тимчасово) — CSV файли',
    'Created At': 'Дата створення',
    Filename: 'Назва файлу',
    Status: 'Статус',
    Error: 'Помилка',
    Actions: 'Дії',
    Download: 'Завантажити',
  },
};
